import { gql } from "@apollo/client";

const GET_USER_BY_EMAIL = gql`
  query user($query: FindUserInput!, $searchInWprDB: Boolean) {
    user(query: $query, searchInWprDB: $searchInWprDB) {
      id
      name
      email
      surname
      avatar
    }
  }
`;

export default GET_USER_BY_EMAIL;
